import { CURRENT_FFS_API_VERSION } from '../core/constants';
import { EnvironmentType, PerimeterType } from '../index';
import { ResponseError } from './errors';
const REQUEST_TIMEOUT = 2000;
const PROD_BASE_URL = 'https://api.atlassian.com/flags';
const STAGING_FEDRAMP_BASE_URL = 'https://api.atlassian-fex.com/flags';
const STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
const GATEWAY_BASE_URL = '/gateway/api/flags';
export default class Fetcher {
  constructor(apiKey, serviceEnv = EnvironmentType.PROD, baseUrl, useGatewayURL = false, perimeter) {
    this.apiKey = apiKey;
    this.baseUrl = Fetcher.buildBaseUrl(serviceEnv, baseUrl, useGatewayURL, perimeter);
  }
  async fetchFeatureFlags(user, metadata, version) {
    const requestBody = {
      apiKey: this.apiKey,
      identifier: user.identifier,
      isAnonymous: user.isAnonymous,
      additionalIdentifiers: user.additionalIdentifiers,
      customAttributes: user.custom,
      versionData: version,
      metadata
    };

    // in case there are still IE users, check AbortController before init,
    // IE has no timeout applied on fetch since AbortController isn't available
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeoutId = setTimeout(() => controller === null || controller === void 0 ? void 0 : controller.abort(), REQUEST_TIMEOUT);
    try {
      const response = await fetch(`${this.baseUrl}/api/${CURRENT_FFS_API_VERSION}/frontend/featureFlagValues`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Client-Name': metadata.client.name,
          'X-Client-Version': metadata.client.version,
          'X-Api-Key': this.apiKey
        },
        body: JSON.stringify(requestBody),
        signal: controller === null || controller === void 0 ? void 0 : controller.signal
      });
      const successfulResponse = await Fetcher.handleResponseError(response);
      return Fetcher.extractBody(successfulResponse);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      clearTimeout(timeoutId);
    }
  }
  static async handleResponseError(response) {
    if (!response.ok) {
      // Use text() instead of json() as the error body might not be json data
      const body = await response.text();
      throw new ResponseError(response.status, body);
    }
    return response;
  }
  static async extractBody(response) {
    if (response.status === 204) {
      return {};
    }
    return response.text().then(text => JSON.parse(text || '{}'));
  }
  static buildBaseUrl(serviceEnv, baseUrl, useGatewayURL = false, perimeter) {
    if (baseUrl) {
      return baseUrl;
    }
    if (useGatewayURL) {
      return GATEWAY_BASE_URL;
    }
    if (serviceEnv === EnvironmentType.DEV || serviceEnv === EnvironmentType.LOCAL) {
      return DEV_BASE_URL;
    }
    if (serviceEnv === EnvironmentType.STAGING) {
      if (perimeter === PerimeterType.FEDRAMP_MODERATE) {
        return STAGING_FEDRAMP_BASE_URL;
      }
      return STAGING_BASE_URL;
    }
    return PROD_BASE_URL;
  }
}